import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 43.25rem;
  margin: 0 auto;

  > h1 {
    text-align: center;
  }
`;

export const FormDataClient = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem 1rem;
  grid-template-areas: "nome" "cpf" "telefone" "email" "buttons";

  > :nth-child(1) {
    grid-area: nome;
  }

  > :nth-child(2) {
    grid-area: cpf;
  }

  > :nth-child(3) {
    grid-area: telefone;
  }

  > :nth-child(4) {
    grid-area: email;
  }
  > :nth-child(5) {
    grid-area: buttons;

    display: flex;
    margin: 0 auto;
    gap: 0 2rem;
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: "nome nome" "cpf telefone" "email email" "buttons buttons";
  }
`;
